/**
 * Profile Generator API — thin wrapper over the shared axios instance
 * (auth header + /api base are configured there). Backend:
 * /api/profile-generator (see backend/routes/profileGenRoutes.js).
 */
import api from '../../api/axios';

const BASE = '/profile-generator';

export const pgApi = {
  // Profiles
  listProfiles: () => api.get(`${BASE}/profiles`).then((r) => r.data.profiles || []),
  getProfile: (id) => api.get(`${BASE}/profiles/${id}`).then((r) => r.data),
  createProfile: (body) => api.post(`${BASE}/profiles`, body).then((r) => r.data),
  updateProfile: (id, body) => api.put(`${BASE}/profiles/${id}`, body).then((r) => r.data),
  deleteProfile: (id) => api.delete(`${BASE}/profiles/${id}`).then((r) => r.data),

  // Templates
  listTemplates: () => api.get(`${BASE}/templates`).then((r) => r.data.templates || []),
  getTemplate: (id) => api.get(`${BASE}/templates/${id}`).then((r) => r.data),
  createTemplate: (body) => api.post(`${BASE}/templates`, body).then((r) => r.data),
  updateTemplate: (id, body) => api.put(`${BASE}/templates/${id}`, body).then((r) => r.data),
  deleteTemplate: (id) => api.delete(`${BASE}/templates/${id}`).then((r) => r.data),

  // Asset library
  listAssets: (type) =>
    api.get(`${BASE}/assets`, { params: type ? { type } : {} }).then((r) => r.data.assets || []),
  uploadAsset: (formData) =>
    api.post(`${BASE}/assets`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data.asset),
  deleteAsset: (id) => api.delete(`${BASE}/assets/${id}`).then((r) => r.data),
};

export default pgApi;
